module.exports = __webpack_public_path__ + "img/rz_05.ec0fd39a.png";